import axios from './axios';
import {
  HubImportOptions,
  HubImportResponse,
} from '../types/HubImport';

const createImportFormData = ({ file }: HubImportOptions) => {
  const formData = new FormData();
  formData.append('file', file);

  return formData;
};

export const previewHubImport = async (options: HubImportOptions): Promise<HubImportResponse> => {
  const response = await axios.post<HubImportResponse>(
    '/hub/import/preview',
    createImportFormData(options),
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
};

export const importHubs = async (options: HubImportOptions): Promise<HubImportResponse> => {
  const response = await axios.post<HubImportResponse>(
    '/hub/import',
    createImportFormData(options),
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
};
